import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => state?.backlogState || initialState;

export const selectIsLoading = createSelector(
  [selectDomain],
  (state) => state.isLoading,
);

export const selectPlanningItems = createSelector(
  [selectDomain],
  (state) => state.planningItems,
);
export const selectSelectedViewType = createSelector(
  [selectDomain],
  (state) => state.selectedViewType,
);

export const selectSelectedPlanningTile = createSelector(
  [selectDomain],
  (state) => state.selectedPlanningTile,
);

export const selectPlanningFilterLoading = createSelector(
  [selectDomain],
  (state) => state.isPlanningFilterLoading,
);
